import { render, staticRenderFns } from "./TheSoftPhone.vue?vue&type=template&id=3c4bf142&scoped=true"
import script from "./TheSoftPhone.vue?vue&type=script&lang=js"
export * from "./TheSoftPhone.vue?vue&type=script&lang=js"
import style0 from "./TheSoftPhone.vue?vue&type=style&index=0&id=3c4bf142&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4bf142",
  null
  
)

export default component.exports